import {
  IonIcon, IonItem, IonLabel, IonList, IonPage,
} from '@ionic/react';
import {
  chevronBackOutline,
} from 'ionicons/icons';
import React from 'react';
import { useHistory } from 'react-router';

import ArrowIcon from '@/assets/icons/menu-selector-arrow-right-red.svg';
import { ROUTES_PATH } from '@/constants';

import styles from './Help.module.scss';

export default function Help() {
  const history = useHistory();
  return (
    <IonPage className={styles.pageHelpContainer}>
      <div className={styles.pageHelp}>
        <div className={styles.pageHelpTitle}>
          <IonIcon
            md={chevronBackOutline}
            className={styles.pageHelpTitleIcon}
            onClick={() => {
              history.goBack();
            }}
          />
          <IonLabel className={styles.pageHelpTitleInfo}>
            Ayuda
          </IonLabel>
        </div>
        <div className={styles.pageHelpContent}>
          <div className={styles.pageHelpContentTitle}>
            <IonLabel className={styles.principalTitle}>¿Necesitas ayuda?</IonLabel>
            <IonLabel className={styles.principalSubtitle}>Echa un vistazo a las preguntas frecuentes o lee la documentación.</IonLabel>
          </div>

          <IonList className={styles.listHelp}>
            <IonItem
              className={styles.listItems}
              onClick={() => history.push(ROUTES_PATH.FAQ)}
            >
              <div className={styles.listItemsData}>
                <IonLabel className={styles.listItemsText}>Preguntas frecuentes</IonLabel>
                <IonIcon src={ArrowIcon} className={styles.listItemsIcon} />
              </div>
            </IonItem>
            <IonItem
              className={styles.listItems}
              onClick={() => history.push(ROUTES_PATH.DOCUMENTS)}
            >
              <div className={styles.listItemsData}>
                <IonLabel className={styles.listItemsText}>Documentación</IonLabel>
                <IonIcon src={ArrowIcon} className={styles.listItemsIcon} />
              </div>
            </IonItem>
          </IonList>
        </div>
      </div>
    </IonPage>
  );
}
